import React from 'react';
import './LoadingSpinner.css';

const LoadingFallback = () => {
  return (
    <div className="loading-container">
      <div className="loading-content">
        <div className="loading-logo">
          <div className="logo-icon bounce-in">📚</div>
          <h1 className="loading-title fade-in">
            Dr. Babasaheb Ambedkar History
          </h1>
          <p className="loading-subtitle fade-in-delay-1">
            Loading historical content...
          </p>
        </div>
        
        <div className="loading-spinner-container">
          <div className="modern-spinner">
            <div className="spinner-ring"></div>
            <div className="spinner-ring"></div>
            <div className="spinner-ring"></div>
          </div>
        </div>
        
        <div className="loading-progress">
          <div className="progress-bar">
            <div className="progress-fill"></div>
          </div>
          <div className="loading-dots fade-in-delay-2">
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </div>
        </div>
      </div>
      
      <div className="loading-background">
        <div className="bg-gradient"></div>
        <div className="floating-particles">
          {[...Array(6)].map((_, i) => (
            <div key={i} className={`particle particle-${i + 1}`}></div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LoadingFallback;
